<script lang="ts">
  import { onMount } from "svelte";
  import { Route } from "svelte-router-spa";
  import { Button, Col, Container, Input, Row } from "sveltestrap";

  import Cookies from "js-cookie";
  import axios from "axios";
  import moment from "moment";

  import Spacer from "@/components/spacer.svelte";
  import Editor from "@/components/editor.svelte";

  import documentapi from "@/functions/api/documentapi";
  import boardapi from "@/functions/api/boardapi";
  import type { IBoard } from "@/types";

  export let currentRoute;

  const code = currentRoute.namedParams.code as string;

  let isauth = Cookies.get("auth");
  let data = "";
  let boardlist: IBoard[];
  let currentBoard: IBoard;

  onMount(async () => {
    const result = await boardapi.boardlist();
    boardlist = result.boardlist;
    currentBoard = boardlist.find((x) => x.code == code);
  });

  const ev저장버튼클릭 = async (event) => {
    const date = (document.getElementById("date") as HTMLInputElement).value;
    console.log(date);
    const title = (
      document.getElementById("document_title") as HTMLInputElement
    ).value;
    const result = await documentapi.post(
      code,
      title,
      data,
      new Date(date).getTime()
    );

    if (result.status.toString().startsWith("2")) {
      location.href = `/board/list/${code}`;
    } else {
      alert("오류가 있어서 글 작성이 안되었습니다");
    }
  };

  const ev목록버튼클릭 = () => {
    location.href = `/board/list/${code}`;
  };
</script>

<Container>
  <Spacer size="10rem" />
  {#if isauth == "true"}
    {#if currentBoard != null}
      <h1>{currentBoard.name}</h1>
      <Spacer size="2rem" />

      <Row>
        <Col xs="1">글 제목</Col>
        <Col xs="6">
          <Input id="document_title" placeholder="제목" />
        </Col>
      </Row>
      <Spacer size="1rem" />
      <Row>
        <Col xs="1">작성일</Col>
        <Col xs="2">
          <Input type="date" id="date" placeholder="date" />
        </Col>
      </Row>

      <Spacer size="1rem" />

      <Editor bind:data />

      <Spacer size="1rem" />
      <Button id="savebutton" color="success" on:click={ev저장버튼클릭}>
        저장
      </Button>
      <Button id="listbutton" outline on:click={ev목록버튼클릭}>목록</Button>
    {/if}
    <!-- {#if iscodevalid == true}{:else if iscodevalid == false}
    <h3>없는 게시판 입니다</h3>
  {/if} -->
    <Spacer size="10rem" />
  {:else}
    <h3>access denied</h3>
    <Spacer size="10rem" />
  {/if}
</Container>

<Route {currentRoute} />
